import "./_vendor";
import 'lazysizes';
import vars, {addClass, removeClass} from "./_vars";
import "./_functions";
import "./_components";
import {menuFunc} from "./functions/menu";
import {customCursor} from "./functions/cursor";
import {resultVideoPlay} from "./functions/result-play";
import {animationsFunc} from "./functions/animations";
import {clientsPlay} from "./functions/clientsPlay";
import {priceTableFunc} from "./functions/priceTableFunc";
import {advantagesFunc} from "./functions/advantagesFunc";
import {customSelect} from "./functions/customSelect";
import {modalLogic} from "./functions/modalLogic";
import {portfolioSort} from "./functions/portfolioSort";
import LazyLoad from "vanilla-lazyload";
import {drainAnimation} from "./functions/drain-animation.js";
new LazyLoad();

history.scrollRestoration = "manual";
window.scrollTo({
   top: 0,
   left: 0,
   behavior: 'instant',
});
function init() {
   const scrollTopBtn = document.querySelector(".scroll-top-btn");
   const initStickyScroll = () => {
      const header = document.querySelector(
         ".header[data-transparent='true']"
      );
      if (window.innerWidth > 300) {
         window.addEventListener("scroll", () => {
            const top = window.scrollY;
            top > 1600
               ? addClass(vars.bodyEl, "--hide")
               : removeClass(vars.bodyEl, "--hide");
            if (header) {
               top > 30
                  ? (header.dataset.transparent = "false")
                  : (header.dataset.transparent = "true");
            }
            if (scrollTopBtn) {
               top > 400
                  ? addClass(scrollTopBtn, "show")
                  : removeClass(scrollTopBtn, "show");
            }
         });
      }
   };
   scrollTopBtn.addEventListener("click", () => window.scrollTo({
      top: 0,
      left: 0,
   }));

   initStickyScroll();
   window.addEventListener("orientationchange", () => {
      initStickyScroll();
   });

   setTimeout(() => {
      document.body.classList.add("--visible"); // Анимация в блоке hero
      const heroItems = document.querySelectorAll(".hero__item");
      heroItems.forEach((item, index) => {
         setTimeout(() => {
            addClass(item, "show");
         }, index * 700);
      });
   }, 350);

   menuFunc();
   modalLogic();
   resultVideoPlay();
   customCursor();
   animationsFunc();
   clientsPlay();
   priceTableFunc();
   advantagesFunc();

   customSelect();

   portfolioSort();
   drainAnimation();
}
if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);